"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ansi_to_react_1 = __importDefault(require("ansi-to-react"));
class TextDisplay extends react_1.default.PureComponent {
    render() {
        return (react_1.default.createElement("pre", null,
            react_1.default.createElement(ansi_to_react_1.default, { linkify: false }, this.props.data)));
    }
}
TextDisplay.MIMETYPE = "text/plain";
TextDisplay.defaultProps = {
    data: "",
    mediaType: "text/plain"
};
exports.default = TextDisplay;
